export const googleCloudPath =
  "https://images-matchbus-192820.storage.googleapis.com/";
export const pdfCloudPath =
  "https://images-matchbus-192820.storage.googleapis.com/pdf/";
export const startpagePicturePath =
  //"https://test-images-192820.storage.googleapis.com/startpagePicture/";
  "https://images-matchbus-192820.storage.googleapis.com/startpagePicture/";
export const internPath =
  "https://images-matchbus-192820.storage.googleapis.com/intern/";

export const formatFullDate = "dd.MM.yyyy HH:mm";
export const germanDateFormat = "dd.MM.yyyy";
export const formatLocalDateDateFns = "P";
export const formatLocalDateTimeDateFns = formatLocalDateDateFns + " p O";

export const BACKEND_API_BASE_PATH = "/api/matchbus";

export const MATCHBUS_SESSION_COOKIE_NAME = "matchbus-next_js";
